export const githubUsername = "LeszekM12";